import { Controller } from "@hotwired/stimulus"

// One collapsible section on the contact card — Contact, Employment,
// Relationships, Activity. The Chrome extension's side panel folds the same
// sections the same way; this is the web half of that pattern, down to the
// chevron and to WHAT is remembered.
//
// Folded state is keyed on the SECTION, not on the contact: "I never want to
// see Employment" is a preference about the card, and re-collapsing the same
// section on every person you open is what made per-contact memory wrong.
const STORE = "emailpa-contact-folded"

export default class extends Controller {
    static targets = ["toggle", "body"]
    static values = { key: String }

    connect() {
        if (this._folded().includes(this.keyValue)) this._apply(false, false)
    }

    toggle() {
        this._apply(this.toggleTarget.getAttribute("aria-expanded") !== "true", true)
    }

    _apply(open, remember) {
        this.toggleTarget.setAttribute("aria-expanded", String(open))
        this.bodyTarget.hidden = !open
        if (!remember) return

        const keys = new Set(this._folded())
        if (open) keys.delete(this.keyValue)
        else keys.add(this.keyValue)
        try {
            window.localStorage.setItem(STORE, JSON.stringify([...keys]))
        } catch (_error) {
            /* a private window still folds, it just forgets */
        }
    }

    _folded() {
        try {
            const saved = JSON.parse(window.localStorage.getItem(STORE) || "[]")
            return Array.isArray(saved) ? saved : []
        } catch (_error) {
            return []
        }
    }
}
